export const HISTORY = {
  de: [
    { date: "März 2026", text: "Erstes eigenes Event unter Freunden – Tavernenabend in der Baronie Whitestone." },
    { date: "Juni 2026", text: "Gründung der Tales&Legends gUG als Träger für unsere Events." },
    { date: "August 2026", text: "Support des Wayfarer-Lagers auf dem Conquest of Mythodea 2026." },
  ],
  en: [
    { date: "March 2026", text: "Our first own event among friends – a tavern night in the Barony of Whitestone." },
    { date: "June 2026", text: "Founding of Tales&Legends gUG as the organization behind our events." },
    { date: "August 2026", text: "Supported the Wayfarer camp at Conquest of Mythodea 2026." },
  ],
};
